import queryString from 'query-string'
import getRequest from '../getRequest'

/**
 * Requests a groupUA update from a cloud function
 * @param {string} groupId id of the district, school, teacher or class
 * @param {string} assessmentId id of the assessment
 * @param {*} year school year (e.g. 2018)
 */
export default function requestGroupUAUpdate (groupId, assessmentId, year) {
  console.log(year)
  const BASE_URL = 'https://us-central1-bellwork-cg1.cloudfunctions.net/updateGroupUA?'
  // const BASE_URL = 'http://localhost:5001/bellwork-cg1/us-central1/updateGroupUA?'
  const queryObj = {
    groupId,
    assessmentId,
    year,
  }
  const query = queryString.stringify(queryObj)
  const endpoint = BASE_URL + query
  console.log('endpoint', endpoint)
  return getRequest(endpoint, 180000)
}

// https://us-central1-bellwork-cg1.cloudfunctions.net/updateGroupUA?groupId=f80294a0-00da-11e9-87c3-15d0cdbe12aa&assessmentId=6e60eb20-172e-11e8-8bfb-cb0010808928&year=2018


// WEBPACK FOOTER //
// ./src/helpers/assessment/requestGroupUAUpdate.js